// import glo from '../../main'
import { tkParse } from '@moke/vue-tk'
import searchRoom from './component/wyOrder/searchRoom.vue'
import stateSearch from './component/electricity/stateSearch.vue'
export default {
  className: 'order',
  title: '水费订单',
  render: (record) => {
    return record.orderId
  },
  fields: [
    'orderId',
    {
      name: 'room',
      width: 180,
      validators: [
        (val) => val ? null : '房间号不可为空'
      ],
      search: {
        component: searchRoom
      }
    },
    {
      name: 'user',
      searchKey: ['nickName'],
      note: '缴费人',
      listWhere: (where) => {
        where.isAdmin = {
          $ne: true
        }
      },
      render: (record) => {
        return (record.user && record.user.nickName) || ''
      }
    },
    {
      name: 'state',
      search: {
        component: stateSearch
      }
    },
    {
      name: 'money',
      width: 120,
      note: '金额'
    },
    'timeDone',
    {
      name: 'remark'
    }
  ],
  search: [
    'orderId',
    'room',
    'state',
    'user'
  ],
  action: {
    edit: {
      type: 'row',
      text: '编辑',
      component: 'akModelEditor',
      fieldsPlus: { // 对默认使用ModelEditor的action有效，可以修改fields在编辑时的属性
        room: {
          disabled: true
        }, // 隐藏一个字段
        user: {
          disabled: true
        },
        state: {
          disabled: true
        },
        money: {
          disabled: true
        },
        timeDone: {
          disabled: true
        }
      }
    },
    complete: {
      type: 'row',
      text: '完成',
      callback: async ({ record, vm }) => {
        await vm.confirm('警告', '确定此订单完成了吗？')
        try {
          await tkParse.put(`/classes/order/${record.objectId}`, {
            state: 'completed',
            timeDone: new Date().toISOString()
          })
          vm.$notification['success']({
            message: '订单已完成'
          })
          vm.refresh()
        } catch (e) {
          console.log('完成水费订单异常', e)
          return vm.$notification['error']({
            message: '网络错误,请重试'
          })
        }
      },
      hidden: ({ record }) => {
        return record && record.state === 'completed'
      }
    },
    delete: false,
    create: false
  },
  hooks: {
    beforeFetch ({ where }) {
      where.type = 'water'
      if (!where.state) {
        where.state = {
          $ne: 'bePaid'
        }
      }
    }
  }
}
